export default __webpack_public_path__ + "static/media/Scheduling_Filled.f57c8f9a.svg";